function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { CarouselContext } from './CarouselContext';
import { StyledCarouselSlide } from './elements';
export const CarouselSlide = ({
  children,
  ...props
}) => {
  const {
    elementWidth
  } = useContext(CarouselContext);
  return /*#__PURE__*/React.createElement(StyledCarouselSlide, _extends({
    as: 'li'
  }, props, {
    $elementWidth: elementWidth,
    $span: React.Children.count(children)
  }), /*#__PURE__*/React.createElement(StyledCarouselSlide, {
    as: 'ul',
    $elementWidth: elementWidth,
    $span: React.Children.count(children)
  }, children));
};